/**
 * Given an image URL, return a promise that resolves when image is loaded.
 */
export const loadImage = (url, crossOrigin = 'anonymous') =>
    new Promise((resolve, reject) => {
        const img = new window.Image();

        img.crossOrigin = crossOrigin;
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.setAttribute('src', url);
    });

/**
 * Given an image URL and valid cropMask, return a promise that resolves with data URL of cropped image
 */
export const getCroppedImageDataURL = (url, cropMask) =>
    loadImage(url).then((image) => {
        const canvas = document.createElement('canvas');

        canvas.setAttribute('width', cropMask.width);
        canvas.setAttribute('height', cropMask.height);

        const context = canvas.getContext('2d');

        context.drawImage(
            image,
            cropMask.x,
            cropMask.y,
            cropMask.width,
            cropMask.height,
            0,
            0,
            cropMask.width,
            cropMask.height,
        );
        return canvas.toDataURL('image/png');
    });
